<!--suppress ALL -->
<script lang="ts">
import {kamars} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";
  import AppConfig from "../../../AppConfig";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class KamarSelect extends Vue {

    @Prop({default: kamars[0], type: String})
    private kamar: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({default: false, type: Boolean})
    public disabled: boolean;

    @Prop({
      default: () => AppConfig.getVm().$t('label.kamar').toString(),
      type: String
    })
    public label: string;

    @Prop({type: String, default: ""})
    public message: string;

    @Prop({type: String, default: ""})
    public type: string;

    public onSelectKamar(param: string) {
      this.$emit('update:kamar', param || kamars[0].value);
      this.$emit('kamar-selected', param);
    }

    public render(createElement: Function) {
      const {$t, kamar, isFullwidth, label, message, type} = this;

      const mainAttr: any = {
        attrs: {disabled: this.disabled},
        props: {
          value: kamar, isFullwidth,
          placeholder: `${$t('label.choose')} ${label}`
        },
        on: {change: this.onSelectKamar}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(kamars).map((item: any) => {
        const option: any = {attrs: {value: item.value}};

        return createElement('option', option, item.label);
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label, message, type}}, [main]);
    }
  }
</script>
